import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditAziendaComponent } from "../edit-azienda/edit-azienda.component";
import { NtMedicineInterface } from '../../../../shared/interfaces/nt-medicine.interface';
import { CustomDateFormatPipe } from "../../../../pipes/custom-date-format.pipe";
import { AuthService } from '../../../../services/auth/auth.service';
import { FormsModule } from '@angular/forms';
import { EditMedicineInformationComponent } from "../../pages/farmaco/components/edit-medicine-information/edit-medicine-information.component";
import { DataService } from '../../../../services/dashboard/data.service';

@Component({
  selector: 'app-info-product-modal',
  imports: [CommonModule, EditAziendaComponent, CustomDateFormatPipe, FormsModule, EditMedicineInformationComponent],
  templateUrl: './info-product-modal.component.html',
  styleUrl: './info-product-modal.component.css'
})
export class InfoProductModalComponent {
  @Input() index: number = 0;
  @Input() farmacoToShowData!: NtMedicineInterface;
  @Output() close = new EventEmitter<void>();

  openModalAzienda: boolean = false;
  openModalEditMedInfo: boolean = false;

  userCanEdit: boolean = false;

  constructor (private authService: AuthService, private dataService: DataService) { }

  ngOnInit (): void {
    console.log(this.farmacoToShowData);

    this.userCanEdit = this.authService.isSuperUser() || this.authService.isAdmin();
    //this.farmacoToShowData.medicineBrandInfo.logo.url=""
  }

  recieveIndex (indexRecieved: number) {
    this.index = indexRecieved;
  }

  closeModal () {
    this.close.emit();
  }

  openAzienda () {
    this.openModalAzienda = true;
  }

  openModalAziendaFromChild (event: boolean): void {
    this.openModalAzienda = event;
  }

  editMedicineInfo (event: boolean) {
    this.openModalEditMedInfo = event;
  }

  saveMedicineInfo (editedMedcinieInfo: any) {
    this.openModalEditMedInfo = false;
    this.farmacoToShowData = editedMedcinieInfo;
    let medicineId = this.farmacoToShowData.id;
    let companyId = sessionStorage.getItem('companyId') || '';
    this.dataService.updateMedicineData(companyId, medicineId, editedMedcinieInfo).subscribe({
      next: (response: any) => {
        console.log("Update successful", response);
      },
      error: (error: any) => {
        console.error("Error updating medicine info", error);
      }
    });
  }

  cancelEditMedicineInfo () { this.openModalEditMedInfo = false; }
}


